import { useEffect, useState } from 'react';
import { Checkbox } from 'src/components/atoms';
import { FormState } from 'src/types';
import { DropdownOptions } from './FilterSelect';
import {
  CheckboxItemStyled,
  FilterSelectDropDownContainer,
} from './FilterSelect.styles';

type FilterSelectDropDownProps = {
  menuIsOpen: boolean;
  size: 'small' | 'medium' | 'large';
  options: DropdownOptions[];
  state: FormState;
  $zIndex?: number;
  onChange: (value: DropdownOptions[]) => void;
  setNumberOfSelected: (itemsSelected: number) => void;
};

export const FilterSelectDropDown = (props: FilterSelectDropDownProps) => {
  const { options, setNumberOfSelected } = props;
  const [items, setItems] = useState(options);

  useEffect(() => {
    setItems(options);
    const selectedCount = options.filter((o) => o.checked).length;
    setNumberOfSelected(selectedCount);
  }, [options, setNumberOfSelected]);

  const handleSelect = (selectedItem: DropdownOptions) => {
    const newItems = items.map((option: DropdownOptions) => {
      if (option.value === selectedItem.value) {
        option.checked = !option.checked;
      }
      return option;
    });
    setItems(newItems);
    props.setNumberOfSelected(newItems.filter((item) => item.checked).length);
    props.onChange(newItems);
  };

  return (
    <FilterSelectDropDownContainer
      $zIndex={props.$zIndex}
      $menuIsOpen={props.menuIsOpen}
      $size={props.size}
    >
      {items.map((item: DropdownOptions) => (
        <CheckboxItemStyled
          key={item.value}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Checkbox
            onChange={() => {
              handleSelect(item);
            }}
            checked={item.checked}
            disabled={props.state === FormState.DISABLED}
            label={item.label}
            labelPosition="left"
            variant="default"
            clickableRow={true}
            $justifyContent="space-between"
            $width="100%"
          />
        </CheckboxItemStyled>
      ))}
    </FilterSelectDropDownContainer>
  );
};
